<template>
   <div>

      <ddoAlert :errors="level.errors"/> 

      <v-card-actions>
         <div class="flex-grow-1"></div>
         <v-btn v-if="level.dialogValues.form_close"  small class="warning" rounded @click="close_window">{{ $t('buttons.close') }}</v-btn>
         <v-btn v-if="level.dialogValues.form_create" small class="primary" rounded :disabled="level.dialogValues.disable_create" @click="create_row(row)">{{ $t('buttons.create') }}</v-btn>
         <v-btn v-if="level.dialogValues.form_update" small class="primary" rounded :disabled="level.dialogValues.disable_update" @click="update_row(row)">{{ $t('buttons.update') }}</v-btn>
         <v-btn v-if="level.dialogValues.form_delete" small class="error"   rounded :disabled="level.dialogValues.disable_delete" @click="delete_row(row)">{{ $t('buttons.delete') }}</v-btn>
      </v-card-actions>
   </div>
</template>

<script>
import CardUpdatable from '@/components/partials/CardUpdatable.vue';

export default {
    name: 'CardUpdatableFooter',
    extends: CardUpdatable,
    data: function () {
        return {
        };
    },

    inject: ['refresh_rows'],

    methods: {

        close_window() {
           console.log('close_window, BEGIN, api_code='+this.level.api_code+', this.level.level='+this.level.level);
           if ( this.level.callbacks.hide_dialog ) {
              this.level.callbacks.hide_dialog(this.level.level);
           } else {
              this.level.dialogValues.dialogShow = false;
           }
           console.log('close_window, dialogShow='+this.level.dialogValues.dialogShow);
        },

        async create_row(row) {
            console.log('IN create_row, row='+JSON.stringify(row));
            if ( this.level.callbacks.create_row ) {
               var { errorinfos, api_response } = await this.level.callbacks.create_row(this.$router,this.level.api_code,row);
            } else {
               var { errorinfos, api_response } = await this.$api.createRow(this.$router,this.level.api_code,row);
            }
            //console.log('IN create_row, AFTER create_row/createRow, errorinfos='+JSON.stringify(errorinfos));
            console.log('IN create_row, AFTER create_row/createRow, api_response='+JSON.stringify(api_response));
            //this.$emit('errors',this.level.level,[errorinfos]);
            if ( api_response.error== 0 ) {
               this.refresh_rows(this.level.childKey);
               if ( this.level.callbacks.show_dialog ) {
                  console.log('IN create_row, BEFORE calling show_dialog callbacks, with FALSE');
                  this.level.callbacks.show_dialog(this.level.level,false);
               }
            } else {
               // ERRORS !
               if ( this.level.callbacks.refresh_errors ) {
                  this.level.callbacks.refresh_errors(this.level.level,[errorinfos]);
               }
            }
            if ( this.level.callbacks.after_create_row ) {
               await this.level.callbacks.after_create_row(this.level.level,errorinfos,api_response);
            }
        },

        async update_row(row) {
            //console.log('update_row, NATIF');
            if ( this.level.callbacks.update_row ) {
               //console.log('update_row, un callback existe, row='+JSON.stringify(row));
               var { errorinfos, api_response } = await this.level.callbacks.update_row(this.$router,this.level.api_code,row._pk,row);
               //console.log('update_row, affichage errors');
               if ( this.level.callbacks.refresh_errors ) {
                  this.level.callbacks.refresh_errors(this.level.level,[errorinfos]);
               }
            } else {
               //console.log('update_row, pas de callback, _pk='+row._pk);
               var { errorinfos, api_response } = await this.$api.updateRow(this.$router,this.level.api_code,row._pk, row);
            }
            //console.log('update_row, NATIF, AFTER AWAIT, api_response='+JSON.stringify(api_response));
            if ( api_response.error==0 ) {
               //console.log('update_row, refresh_rows');
               this.refresh_rows(this.level.childKey);
               //console.log('update_row, fermeture fenetre');
               if ( this.level.callbacks.show_dialog ) {
                  //console.log('update_row, fermeture fenetre, demande effective');
                  this.level.callbacks.show_dialog(this.level.level,false);
               }
            } else {
               //console.log('update_row, ELSE affichage errors');
               // ERRORS !
               if ( this.level.callbacks.refresh_errors ) {
                  this.level.callbacks.refresh_errors(this.level.level,[errorinfos]);
               }
            }
            if ( this.level.callbacks.after_update_row ) {
               await this.level.callbacks.after_update_row(this.level.level,errorinfos,api_response);
            }
        },

        async delete_row(row) {
            //console.log('delete_row, NATIF');
            if ( this.level.callbacks.delete_row ) {
               var { errorinfos, api_response } = await this.level.callbacks.delete_row(this.$router,this.level.api_code,row._pk,row);
            } else {
               // 2020-06-30, SDO : last parameter is no more 'row', but an actioname... In this case, nothing special...
               //var { errorinfos, api_response } = await this.$api.deleteRow(this.$router,this.level.api_code,row._pk, row);
               var { errorinfos, api_response } = await this.$api.deleteRow(this.$router,this.level.api_code,row._pk);
            }
            //this.$emit('errors',this.level.level,[errorinfos]);
            if ( api_response.error== 0 ) {
               this.refresh_rows(this.level.childKey);
               if ( this.level.callbacks.show_dialog ) {
                  this.level.callbacks.show_dialog(this.level.level,false);
               }
            } else {
               // ERRORS !
               if ( this.level.callbacks.refresh_errors ) {
                  this.level.callbacks.refresh_errors(this.level.level,[errorinfos]);
               }
            }
            if ( this.level.callbacks.after_delete_row ) {
               await this.level.callbacks.after_delete_row(this.level.level,errorinfos,api_response);
            }
        },
    },
  
}
</script>